import React from 'react';
import { ThunderboltOutlined } from '@ant-design/icons';
import { InputNumber } from '@clockout-dev/design-elements';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';

function InstantFeeCard({ value, enabled, onChange, onToggleEnabled }) {
    return (
        <ConfigurationCard
            title="Instant Transfer Fee"
            icon={<ThunderboltOutlined />}
            enabled={enabled}
            onToggleEnabled={onToggleEnabled}
        >
            <InputNumber
                prefix="$"
                value={value}
                onChange={onChange}
                placeholder="0.00"
            />
        </ConfigurationCard>
    );
}

export default InstantFeeCard;
